import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { vacancyQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { VacancyFilters } from "@/lib/contexts/Vacancy/types";
import { GetVacancyCountResponse } from "@/types/response/GetVacancyCountResponse ";

type UseVacancyCountParams = {
  filter: VacancyFilters;
  search?: string;
  includeUnpublished?: boolean;
  clientId?: string;
};

export const useVacancyCount = ({
  filter,
  search,
  includeUnpublished,
  clientId,
}: UseVacancyCountParams) => {
  const {
    data: countByFilter,
    isLoading: countByFilterLoading,
    isFetching: countByFilterFetching,
  }: UseQueryResult<GetVacancyCountResponse, AxiosError> = useQuery({
    queryKey: vacancyQueryKeys.countByFilter(filter, search, includeUnpublished),
    queryFn: () =>
      instance
        .post(
          "/api/v2/Vacancies/CountByFilter",
          {
            ...filter,
            search,
            includeUnpublished,
          },
          {
            params: {
              ...(clientId ? { clientId } : {}),
            },
          }
        )
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

  return {
    countByFilter,
    countByFilterFetching,
    countByFilterLoading,
  };
};
